import { createContext, useContext, RefObject } from 'react'

export const ModalElementContext = createContext<
  () => RefObject<HTMLElement> | null
>(() => null)

export const useModalElementGetter = () => useContext(ModalElementContext)
